import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./PaymentFailed.css";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const message = location.state?.message || "Payment could not be processed.";
  const orderId = location.state?.merchantOrderId || "N/A";

  return (
    <div className="failed-wrapper">
      <div className="failed-card">
        <div className="failed-icon-wrap">
          <svg className="failed-svg" viewBox="0 0 52 52" fill="none">
            <circle className="failed-circle" cx="26" cy="26" r="24" />
            <path className="failed-cross" d="M18 18l16 16M34 18L18 34" strokeLinecap="round" />
          </svg>
        </div>

        <h1 className="failed-heading">Payment Failed</h1>
        <p className="failed-subtext">{message}</p>
        
        <div className="failed-details-box">
           <div className="failed-detail-row">
            <span className="failed-detail-label">Reference ID</span>
            <span className="failed-detail-val">{orderId}</span>
          </div>
        </div>

        <div className="failed-actions">
          <button className="failed-btn failed-btn--primary" onClick={() => navigate("/RoomCard")}>
            Try Again
          </button>
          <button className="failed-btn failed-btn--outline" onClick={() => navigate("/")}>
            Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;